import { render } from "./IconNoSearchResult.vue?vue&type=template&id=062bf42c&ts=true"
import script from "./IconNoSearchResult.vue?vue&type=script&lang=ts"
export * from "./IconNoSearchResult.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__